/**
 * cart-set-multiplier.js — Yakups toptan (SET) sepet mantığı — CONCEPT TEMA SÜRÜMÜ
 *
 * Wonder temasındaki sürümden port edildi. Açıklama parser'ı (parseCompleteSetInfo), set gruplama,
 * darboğaz stok hesabı ve düzeltme mantığı BİREBİR korundu; tema entegrasyonu Concept 5.3.3'e uyarlandı:
 *   - Concept'te adet +/- , elle yazma ve "Kaldır" hepsi cart-items → fetch('/cart/change', JSON{id,quantity,sections})
 *     üzerinden geçer. Bu yüzden buton ele geçirme YOK; tek nokta = fetch interceptor.
 *   - Set satırı güncellemesi TEK /cart/update isteğiyle yapılır ve temanın beklediği `sections`
 *     HTML'i cevaba dahil edilir → drawer + sepet sayfası temanın kendi yoluyla yeniden çizilir.
 *   - Satır DOM'u: tr.cart-item#CartItem-{key} (sepet sayfası), li.horizontal-product#CartDrawer-Item-{key} (drawer),
 *     adet input'u input[name="updates[]"][data-index=key].
 *   - Multi-size set satırları TEK satıra indirilir (rozet + set toplamı), input SET SAYISI gösterir.
 */
(function () {
  'use strict';

  const PRODUCTION_MODE = false; // debug konsol logları AÇIK ([Cart Set] ...)
  let productCache = {};
  let setGroups = new Map();
  const nativeFetch = window.fetch.bind(window);
  const internalRequestFlag = 'SET_MULTIPLIER_INTERNAL_REQUEST';

  // ===== i18n / Çoklu dil desteği =====
  const I18N_STRINGS = {
    tr: {
      setDeleted: '{setType} set tamamen silindi: {title}',
      setDeleteError: 'Set silinirken bir hata oluştu',
      stockLimitedAdjusted: '{title}: Stok yetersiz, {sets} sete ayarlandı. {factor}',
      quantitiesCorrected: '{title}: Miktarlar düzeltildi ({sets} set: {items})',
      stockLimitedMax: 'Stok yetersiz! Maksimum {sets} set. {factor}',
      setAdded: '+{qty} adet (1 set) eklendi',
      setRemoved: '-{qty} adet (1 set) çıkarıldı',
      setTypeMulti: 'Çoklu beden',
      setTypeSingle: 'Tek beden',
      totalLabel: 'Toplam:',
      pieceUnit: 'adet',
      setTotalLabel: 'Set toplamı:'
    },
    ro: {
      setDeleted: 'Setul {setType} a fost complet șters: {title}',
      setDeleteError: 'A apărut o eroare la ștergerea setului',
      stockLimitedAdjusted: '{title}: Stoc limitat, ajustat la {sets} set. {factor}',
      quantitiesCorrected: '{title}: Cantitățile au fost corectate ({sets} set: {items})',
      stockLimitedMax: 'Stoc limitat! Maximum {sets} set. {factor}',
      setAdded: '+{qty} buc. (1 set) adăugat',
      setRemoved: '-{qty} buc. (1 set) eliminat',
      setTypeMulti: 'Multi-size',
      setTypeSingle: 'Single',
      totalLabel: 'Total:',
      pieceUnit: 'buc.',
      setTotalLabel: 'Total set:'
    },
    en: {
      setDeleted: '{setType} set completely removed: {title}',
      setDeleteError: 'An error occurred while removing the set',
      stockLimitedAdjusted: '{title}: Insufficient stock, adjusted to {sets} sets. {factor}',
      quantitiesCorrected: '{title}: Quantities corrected ({sets} sets: {items})',
      stockLimitedMax: 'Insufficient stock! Maximum {sets} sets. {factor}',
      setAdded: '+{qty} pcs (1 set) added',
      setRemoved: '-{qty} pcs (1 set) removed',
      setTypeMulti: 'Multi-size',
      setTypeSingle: 'Single size',
      totalLabel: 'Total:',
      pieceUnit: 'pcs',
      setTotalLabel: 'Set total:'
    }
  };

  function getCurrentLocale() {
    const htmlLang = (document.documentElement.lang || '').toLowerCase().slice(0, 2);
    if (I18N_STRINGS[htmlLang]) return htmlLang;

    const path = (window.location && window.location.pathname) || '';
    const urlMatch = path.match(/^\/([a-z]{2})(?:-[a-z]{2})?\//i);
    if (urlMatch) {
      const urlLang = urlMatch[1].toLowerCase();
      if (I18N_STRINGS[urlLang]) return urlLang;
    }

    if (window.Shopify && window.Shopify.locale) {
      const shopLang = window.Shopify.locale.toString().toLowerCase().slice(0, 2);
      if (I18N_STRINGS[shopLang]) return shopLang;
    }

    return 'tr';
  }

  function t(key, vars) {
    const locale = getCurrentLocale();
    const dict = I18N_STRINGS[locale] || I18N_STRINGS.tr;
    let str = dict[key];
    if (str === undefined) str = (I18N_STRINGS.tr[key] !== undefined) ? I18N_STRINGS.tr[key] : key;
    if (vars) {
      for (const k in vars) {
        str = str.split('{' + k + '}').join(vars[k]);
      }
    }
    return str;
  }

  function log(...args) {
    if (!PRODUCTION_MODE) {
      console.log('[Cart Set]', ...args);
    }
  }

  // Beden ismini normalize et: trim, uppercase, sondaki nokta/boşluğu sil
  function normalizeSize(size) {
    if (size === null || size === undefined) return '';
    return size.toString().toUpperCase().trim().replace(/[.\s]+$/, '');
  }

  // Kapsamlı set bilgisi parse fonksiyonu (quantity-multiplier.js'den uyarlanmış)
  function parseCompleteSetInfo(description, productTitle) {
    if (!description) return null;

    // DEBUG: Ham description'ı logla
    log('RAW DESCRIPTION:', description.substring(0, 500));

    let cleanText = description.toString().trim();
    cleanText = cleanText.replace(/<[^>]*>/g, ' ');
    cleanText = cleanText.replace(/&[a-zA-Z0-9#]+;/g, '');
    cleanText = cleanText.replace(/^\*+/g, '');
    cleanText = cleanText.replace(/\*+$/g, '');
    cleanText = cleanText.replace(/\*/g, '');
    cleanText = cleanText.replace(/[\r\n\t\f\v]/g, ' ');
    cleanText = cleanText.replace(/\s+/g, ' ');
    cleanText = cleanText.trim();

    // Romence -> Türkçe etiket normalizasyonu (çok dilli destek)
    cleanText = cleanText
      .replace(/Conținutul setului:/g, 'Set İçerik Bilgisi:')
      .replace(/Continutul setului:/g, 'Set İçerik Bilgisi:')
      .replace(/Setul de mărimi:/g, 'Beden Seti:')
      .replace(/Setul de marimi:/g, 'Beden Seti:')
      .replace(/Distribuție:/g, 'Dağılım:')
      .replace(/Distribuția:/g, 'Dağılım:')
      .replace(/Distributie:/g, 'Dağılım:')
      .replace(/Distributia:/g, 'Dağılım:');

    log('CLEAN TEXT:', cleanText.substring(0, 500));

    // (Concept port düzeltmesi) Ürün sayfası Liquid'i ile AYNI çıkarım: "Set İçerik Bilgisi:" etiketinden
    // sonraki içerik HAM HTML'de ilk tag'e kadar alınır (150 karakter, strong/yıldız temizlenir). Böylece
    // sonraki paragraflar ("Paket İçeriği: S-M,L-XL,2XL-3XL (2-2-2)", "Continut Pachet: 27:1 - ...")
    // set içeriğine sızıp STD ürünü çoklu-beden set gibi okutmaz.
    let liquidContent = null;
    {
      const rawNorm = description.toString()
        .replace(/Conținutul setului:/g, 'Set İçerik Bilgisi:')
        .replace(/Continutul setului:/g, 'Set İçerik Bilgisi:');
      const label = 'Set İçerik Bilgisi:';
      const li = rawNorm.indexOf(label);
      if (li !== -1) {
        let after = rawNorm.slice(li + label.length, li + label.length + 150);
        after = after.replace(/[\r\n]/g, '').replace(/<\/?strong>/g, '').replace(/\*+/g, '').trim();
        if (after.includes('<')) after = after.split('<')[0].trim();
        if (after) liquidContent = after;
      }
    }
    
    // 1. BEDEN SETİ FORMATI
    if (cleanText.includes('Beden Seti:') && cleanText.includes('Dağılım:')) {
      const variantDistributions = {};
      const sections = cleanText.split('Beden Seti:');
      
      for (let i = 1; i < sections.length; i++) {
        const section = sections[i];
        const dagitimParts = section.split('Dağılım:');
        
        if (dagitimParts.length > 1) {
          const bedenRange = dagitimParts[0].replace(/[()]/g, '').trim();
          const dagitimContent = dagitimParts[1].split(/Barkod|Teknik|$/)[0].trim();
          
          let totalQty = 0;
          const sizeMap = {};
          
          // XS:1 - S:1 - M:1 - L:1 formatını parse et
          const matches = dagitimContent.matchAll(/([A-Z]{1,3}):(\d+)/g);
          for (const match of matches) {
            const size = match[1];
            const qty = parseInt(match[2]);
            sizeMap[size] = qty;
            totalQty += qty;
          }
          
          if (totalQty > 0) {
            variantDistributions[bedenRange] = {
              total: totalQty,
              sizes: sizeMap
            };
          }
        }
      }
      
      if (Object.keys(variantDistributions).length > 0) {
        // Her range için toplam miktarı hesapla
        const totalPerRange = {};
        for (const [range, info] of Object.entries(variantDistributions)) {
          totalPerRange[range] = info.total;
        }

        log('Beden Seti formatı:', variantDistributions);
        return {
          type: 'beden_seti',
          distributions: variantDistributions,
          isMultiSize: true,
          totalPerRange: totalPerRange
        };
      }
    }
    
    // 2. SET İÇERİK BİLGİSİ FORMATI (S-2 M-2 L-2 veya 2S-2M-2L)
    let setContent = null;
    
    if (cleanText.includes('Set İçerik Bilgisi:')) {
      const parts = cleanText.split('Set İçerik Bilgisi:');
      if (parts.length > 1) {
        const endMarkers = [
          // Türkçe
          'Teknik', 'Kumaş', 'Kalıp', 'Kol', 'Beden', 'Bakım', 'Ürün', 'Barkod', 'Model',
          'Marka', 'Renk', 'Manken', 'Yıkama', 'Fotoğraf',
          // (Concept port) düz metin açıklamalarda sonraki etiketler sızmasın
          'Paket', 'Seri', 'Pachet', 'Continut', 'Conținut', 'Cantitate', 'Numărul', 'Numarul', 'Articole',
          // English
          'Product', 'Features', 'Material', 'Care',
          // Romence
          'Caracteristici', 'Materiale', 'Material', 'Croială', 'Croiala', 'Mânecă', 'Maneca',
          'Mărime', 'Marime', 'Întreținere', 'Intretinere', 'Produs', 'Țesătură', 'Tesatura'
        ];
        let content = (liquidContent !== null) ? liquidContent : parts[1];

        // En erken görünen marker'ı bul ve oradan kes
        // (Önemli: for-loop break yerine earliest-index aramak gerekiyor,
        //  yoksa listenin ilk match'inde durup sonraki gerçek end-marker'ı kaçırıyor
        //  ve "Ürün Kodu : 97313-04" set content'e sızıp "313:4" gibi yanlış
        //  beden parse'ına sebep oluyor)
        let earliestIndex = -1;
        for (const marker of endMarkers) {
          const idx = content.indexOf(marker);
          if (idx !== -1 && (earliestIndex === -1 || idx < earliestIndex)) {
            earliestIndex = idx;
          }
        }
        if (earliestIndex !== -1) {
          content = content.substring(0, earliestIndex);
        }
        setContent = content.trim();
      }
    }

    // 3. DAĞILIM FORMATI
    if (!setContent && cleanText.includes('Dağılım:')) {
      const parts = cleanText.split('Dağılım:');
      if (parts.length > 1) {
        setContent = parts[1].split(/Teknik|Kumaş|Kalıp|Kol|Bakım|Barkod|Product|Features|Material|Caracteristici|Materiale|Croială|Croiala|Mânecă|Maneca|Mărime|Marime|Întreținere|Intretinere|Produs|Țesătură|Tesatura/)[0].trim();
      }
    }

    // DEBUG: Set içeriğini logla
    if (setContent) {
      log('SET CONTENT (RAW):', JSON.stringify(setContent));
      log('SET CONTENT (length):', setContent.length);
    }

    // (Concept port düzeltmesi) Ürün sayfası parseSetDistribution ile AYNI öncelik:
    // set içeriğinde STD / xSTANDART varsa çoklu-beden desenlerinden ÖNCE tek-varyant set kabul edilir.
    if (setContent) {
      const stdEarly = setContent.match(/STD-(\d+)/i) || setContent.match(/STD\s*[-:]\s*(\d+)/i) ||
        setContent.match(/(\d+)\s*x\s*STANDART/i) || setContent.match(/(\d+)\s*x\s*STD/i) ||
        setContent.match(/(\d+)xSTANDART/i) || setContent.match(/(\d+)xSTD/i) ||
        setContent.match(/(\d+)\s+STANDART/i) || setContent.match(/STANDART\s+(\d+)/i);
      if (stdEarly) {
        const multiplier = parseInt(stdEarly[1]);
        log('STD formatı (set içeriğinde, öncelikli):', multiplier, 'Pattern:', stdEarly[0]);
        return {
          type: 'std',
          multiplier: multiplier,
          isMultiSize: false
        };
      }
    }

    // Set içeriğini parse et
    if (setContent) {
      const distribution = {};
      let hasMultipleSizes = false;

      // Geçerli beden isimleri - quantity-multiplier.js ile uyumlu
      const excludedWords = new Set(['TRY', 'USD', 'EUR', 'GBP', 'ADET', 'KG', 'TL', 'MAL', 'VE', 'BR', 'DIV', 'EM', 'TEK']);
      const validSizes = new Set(['S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XS', '2XL', '3XL', '4XL', '5XL', '6XL']);

      // YENİ: Parantez formatı - "(S-M)-3" veya "(S-M):3"
      const parenthesisPattern = /\(([A-Z]+(?:-[A-Z]+)*)\)\s*[-:=]\s*(\d+)/gi;
      const parenthesisMatches = [...setContent.matchAll(parenthesisPattern)];

      if (parenthesisMatches.length > 0) {
        log('Parenthesis format detected in cart parser');
        for (const match of parenthesisMatches) {
          const sizeName = match[1].toUpperCase();
          const quantity = parseInt(match[2]);
          if (quantity > 0 && quantity <= 100) {
            distribution[sizeName] = quantity;
            hasMultipleSizes = true;
            log(`Parenthesis format found: (${sizeName})-${quantity}`);
          }
        }
      }

      // YENI: Tire içeren beden isimleri - "S-M-3" veya "L-XL:2"
      // Önce potansiyel tire içeren beden isimlerini tespit et
      if (!hasMultipleSizes) {
        // "S-M-3" veya "S-M:3" veya "S-M=3" formatları
        const compoundSizePattern = /([A-Z]+-[A-Z]+)\s*[-:=]\s*(\d+)/gi;
        const compoundMatches = [...setContent.matchAll(compoundSizePattern)];

        if (compoundMatches.length > 0) {
          log('Compound size format detected in cart parser');
          for (const match of compoundMatches) {
            const sizeName = match[1].toUpperCase();
            const quantity = parseInt(match[2]);
            if (quantity > 0 && quantity <= 100) {
              distribution[sizeName] = quantity;
              hasMultipleSizes = true;
              log(`Compound size found: ${sizeName}-${quantity}`);
            }
          }
        }
      }

      // Önce "S-2 M-2 L-4 XL-4" veya "44-1 46-2" formatını dene (size-quantity)
      if (!hasMultipleSizes) {
        const sizeQuantityPattern = /([A-Z]{1,4}|\d{2,3})\s*[-:]\s*(\d{1,2})/g;
        let matches = [...setContent.matchAll(sizeQuantityPattern)];

        if (matches.length > 0) {
          log('Size-quantity pattern matched, count:', matches.length);
          matches.forEach(match => {
            const size = match[1].toUpperCase();
            const qty = parseInt(match[2]);
            const isNumericSize = /^\d{2,3}$/.test(size);
            // Harf bedenler: validSizes kontrolü, Numeric bedenler: direkt kabul
            if ((isNumericSize || (validSizes.has(size) && !excludedWords.has(size))) && qty > 0 && qty <= 100) {
              distribution[size] = qty;
              hasMultipleSizes = true;
              log(`Size-quantity found: ${size}-${qty}`);
            }
          });
        }
      }

      // "M1-L1-XL1-XXL1" formatı - beden ve adet arasında ayraç yok
      if (!hasMultipleSizes) {
        const concatParts = setContent.split(/[-\s]+/);
        for (const part of concatParts) {
          const concatMatch = part.match(/^([A-Z]{1,4})(\d{1,2})$/i);
          if (concatMatch) {
            const size = concatMatch[1].toUpperCase();
            const qty = parseInt(concatMatch[2]);
            if ((validSizes.has(size) || /^\d{2,3}$/.test(size)) && !excludedWords.has(size) && qty > 0 && qty <= 100) {
              distribution[size] = qty;
              hasMultipleSizes = true;
              log(`Concat size-qty found: ${size}${qty}`);
            }
          }
        }
      }

      // (toserof) Bitişik rakam-önekli beden formatı - "3XL2-4XL1-5XL1-6XL1" (3XL=size, 2=qty)
      if (!hasMultipleSizes) {
        const dpMatches = [...setContent.matchAll(/(\d+XL)(\d+)/gi)];
        for (const m of dpMatches) {
          const size = m[1].toUpperCase();
          const qty = parseInt(m[2]);
          if (validSizes.has(size) && qty > 0 && qty <= 100) {
            distribution[size] = qty;
            hasMultipleSizes = true;
            log(`Digit-prefixed size found: ${size}${qty}`);
          }
        }
      }

      // Eğer size-quantity pattern çalışmadıysa, "2S-2M-4L-4XL" formatını dene
      if (!hasMultipleSizes) {
        const quantitySizePattern = /(\d+)\s*([A-Z]{1,4})(?=\s|-|$)/g;
        let matches = [...setContent.matchAll(quantitySizePattern)];

        if (matches.length > 0) {
          log('Quantity-size pattern matched, count:', matches.length);
          matches.forEach(match => {
            const qty = parseInt(match[1]);
            const size = match[2].toUpperCase();
            // SADECE geçerli beden isimleri kabul et
            if (validSizes.has(size) && !excludedWords.has(size) && qty > 0 && qty <= 100) {
              distribution[size] = qty;
              hasMultipleSizes = true;
              log(`Quantity-size found: ${qty}${size}`);
            }
          });
        }
      }
      
      if (hasMultipleSizes && Object.keys(distribution).length > 0) {
        // Toplam miktar hesapla
        const totalPerSet = Object.values(distribution).reduce((sum, qty) => sum + qty, 0);

        log('Multi-size set bulundu:', distribution);
        return {
          type: 'multi_size_set',
          distribution: distribution,
          isMultiSize: true,
          totalPerSet: totalPerSet
        };
      }
    }
    
    // 4. PAKET YAPISI FORMATI
    if (cleanText.includes('Paket Yapısı:')) {
      const paketMatch = cleanText.match(/Paket Yapısı:\s*(.+?)(?:Teknik|Kumaş|Barkod|$)/i);
      if (paketMatch) {
        const paketContent = paketMatch[1].trim();
        // '+' ile ayrılmış kısımları say veya sayısal değer bul
        let multiplier = 1;

        // "1S+1M+1L+1XL" gibi formatlar için
        const plusParts = paketContent.split('+').filter(p => p.trim());
        if (plusParts.length > 1) {
          multiplier = plusParts.length;
        } else {
          // Direkt sayı formatı için
          const numMatch = paketContent.match(/(\d+)/);
          if (numMatch) {
            multiplier = parseInt(numMatch[1]);
          }
        }

        log('Paket Yapısı formatı:', multiplier);
        return {
          type: 'paket_yapisi',
          multiplier: multiplier,
          isMultiSize: false
        };
      }
    }

    // 5. STD FORMATI
    // "5xSTANDART", "5xSTD", "STD-5", "STD:5" gibi formatları destekle
    let stdMatch = cleanText.match(/(\d+)\s*x\s*STAN[DA]*R[DT]/i);
    if (!stdMatch) {
      stdMatch = cleanText.match(/STD\s*[-:]\s*(\d+)/);
    }
    if (!stdMatch) {
      stdMatch = cleanText.match(/(\d+)\s*x\s*STD/i);
    }

    if (stdMatch) {
      const multiplier = parseInt(stdMatch[1]);
      log('STD formatı bulundu:', multiplier, 'Pattern:', stdMatch[0]);
      return {
        type: 'std',
        multiplier: multiplier,
        isMultiSize: false
      };
    }

    // 6. ÜRÜN ADINDAN SET BİLGİSİ
    if (productTitle) {
      const titleUpper = productTitle.toUpperCase();
      const setPatterns = [
        /(\d+)\s*[''']?\s*[Ll][İIıi]\s*[Ss][Ee][Tt]/,
        /(\d+)\s*[Aa][Dd][Ee][Tt]/,
        /(\d+)\s*[Ll][İIıi]\s*[Pp][Aa][Kk][Ee][Tt]/
      ];
      
      for (const pattern of setPatterns) {
        const match = titleUpper.match(pattern);
        if (match) {
          const multiplier = parseInt(match[1]);
          if (multiplier > 1) {
            return {
              type: 'title_based',
              multiplier: multiplier,
              isMultiSize: false
            };
          }
        }
      }
    }
    
    return null;
  }
  
  // (Concept port) Ürün sayfasındaki AUTO modun karşılığı: açıklamada set bilgisi yoksa ve beden opsiyonu
  // 2+ değerliyse her bedenden 1 parça (ürün sayfası "S-1 M-1 L-1 ..." üretip aynı kabul kuralıyla parse eder:
  // harf bedenler validSizes listesinden, sayısal bedenler 2-3 hane).
  function computeAutoSetInfo(product) {
    if (!product || !Array.isArray(product.options)) return null;
    const rx = /size|beden|boyut|mărime|marime|mărimi|marimi|corp|talie/;
    const opt = product.options.find(o => rx.test(String((o && o.name) || '').toLowerCase()));
    const values = opt && Array.isArray(opt.values) ? opt.values : [];
    if (values.length < 2) return null;

    const excludedWords = new Set(['TRY', 'USD', 'EUR', 'GBP', 'ADET', 'KG', 'TL', 'MAL', 'VE', 'BR', 'DIV', 'EM', 'TEK']);
    const validSizes = new Set(['S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XS', '2XL', '3XL', '4XL', '5XL', '6XL']);
    const distribution = {};
    for (const v of values) {
      const size = normalizeSize(v);
      if (!size || excludedWords.has(size)) continue;
      if (/^\d{2,3}$/.test(size) || validSizes.has(size) || size.includes('-')) distribution[size] = 1;
    }
    const keys = Object.keys(distribution);
    if (!keys.length) return null;

    log('AUTO set (beden opsiyonundan):', distribution);
    return {
      type: 'auto',
      distribution: distribution,
      isMultiSize: true,
      totalPerSet: keys.length
    };
  }

  // ============================================================
  // ROTALAR / YARDIMCILAR (Concept)
  // ============================================================
  function routes() {
    const r = (window.theme && theme.routes) || {};
    return {
      cart: r.cart_url || '/cart',
      add: r.cart_add_url || '/cart/add',
      change: r.cart_change_url || '/cart/change',
      update: r.cart_update_url || '/cart/update'
    };
  }

  function jsonHeaders() {
    return { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  }

  async function fetchCartJson() {
    const r = await nativeFetch('/cart.js', { cache: 'no-store' });
    if (!r.ok) throw new Error(`HTTP error! status: ${r.status}`);
    return r.json();
  }

  function itemHandle(item) {
    if (!item) return null;
    return item.handle || (item.url ? (item.url.split('/products/')[1] || '').split('?')[0] : null) || null;
  }

  // Temanın drawer + sepet sayfası section id'lerini topla (cart.js listener'ları doldurur)
  function collectSections() {
    const sections = [];
    try {
      document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));
    } catch (_) { /* ignore */ }
    return sections;
  }

  function formatMoney(cents) {
    try {
      if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
        return theme.Currency.formatMoney(cents, (theme.settings && theme.settings.moneyFormat) || '');
      }
    } catch (_) { /* fallback */ }
    return (Number(cents) / 100).toFixed(2);
  }

  function cssEscape(v) {
    return (window.CSS && CSS.escape) ? CSS.escape(String(v)) : String(v).replace(/["\\]/g, '\\$&');
  }

  // ============================================================
  // SET GRUPLAMA
  // ============================================================
  async function getProductSetInfo(handle) {
    if (productCache[handle]) {
      return productCache[handle];
    }

    try {
      const response = await nativeFetch(`/products/${handle}.js`);
      if (!response.ok) return null;

      const product = await response.json();
      const setInfo = parseCompleteSetInfo(product.description, product.title) || computeAutoSetInfo(product);

      if (setInfo) {
        setInfo.handle = handle;
        setInfo.productId = product.id;
        setInfo.title = product.title;
        setInfo.variants = product.variants;

        productCache[handle] = setInfo;
        log(`Set bilgisi (${handle}):`, setInfo);
      }

      return setInfo;
    } catch (error) {
      log('Ürün bilgisi alınamadı:', error);
      return null;
    }
  }

  async function groupSetItems(cartArg) {
    const cart = cartArg || await fetchCartJson();
    setGroups.clear();

    for (const item of cart.items) {
      const handle = itemHandle(item);
      if (!handle) continue;

      const setInfo = await getProductSetInfo(handle);
      if (!setInfo) continue;

      if (setInfo.isMultiSize) {
        if (!setGroups.has(handle)) {
          let normalizedDistribution = {};

          if (setInfo.distribution) {
            normalizedDistribution = setInfo.distribution;
          } else if (setInfo.distributions) {
            for (const [range, info] of Object.entries(setInfo.distributions)) {
              if (info.sizes) {
                normalizedDistribution = { ...normalizedDistribution, ...info.sizes };
              }
            }
          }

          setGroups.set(handle, {
            info: setInfo,
            items: [],
            distribution: normalizedDistribution,
            totalPerSet: setInfo.totalPerSet || setInfo.totalPerRange || Object.values(normalizedDistribution).reduce((sum, qty) => sum + qty, 0)
          });
        }

        const group = setGroups.get(handle);

        const variantTitle = item.variant_title || item.title || '';
        log(`--- Cart item: "${item.product_title}" ---`);
        log(`Variant title: "${variantTitle}"`);
        log(`Quantity: ${item.quantity}`);
        log(`Key: ${item.key}`);

        const parts = variantTitle.split('/').map(p => normalizeSize(p));
        log(`Variant parts (normalized):`, parts);

        let sizeKey = null;

        if (group.distribution && Object.keys(group.distribution).length > 0) {
          const sizes = Object.keys(group.distribution).sort((a, b) => b.length - a.length);
          log(`Checking against distribution (sorted):`, sizes);

          for (const variantPart of parts) {
            if (sizeKey) break;

            for (const size of sizes) {
              const normalizedSize = normalizeSize(size);

              if (variantPart === normalizedSize) {
                sizeKey = size;
                log(`✓ Size matched from distribution (exact): ${size} from part "${variantPart}"`);
                break;
              }

              if (normalizedSize.includes('-')) {
                const sizeParts = normalizedSize.split('-').map(s => normalizeSize(s));
                if (sizeParts.includes(variantPart)) {
                  sizeKey = size;
                  log(`✓ Size matched from distribution (partial in compound): ${size} contains ${variantPart}`);
                  break;
                }
              }
            }
          }
        }

        if (!sizeKey) {
          const sizeOptions = ['XXXL', 'XXL', 'XL', 'L', 'M', 'S', 'XS'];
          log(`Checking against size options (sorted):`, sizeOptions);

          for (const variantPart of parts) {
            if (sizeKey) break;

            for (const size of sizeOptions) {
              if (variantPart === size || variantPart.startsWith(size + ' ')) {
                sizeKey = size;
                log(`✓ Size matched from options: ${size} from part "${variantPart}"`);
                break;
              }
            }
          }
        }

        if (sizeKey) {
          const expectedQty = group.distribution?.[sizeKey] || 1;
          log(`✓ Adding to group: size=${sizeKey}, expected=${expectedQty}, current=${item.quantity}`);
          group.items.push({
            ...item,
            size: sizeKey,
            expectedQty: expectedQty,
            key: item.key
          });
        } else {
          log(`✗ Size NOT found for variant: "${variantTitle}"`);
        }
      } else {
        if (!setGroups.has(handle)) {
          setGroups.set(handle, {
            info: setInfo,
            items: [item],
            multiplier: setInfo.multiplier || 1
          });
        } else {
          setGroups.get(handle).items.push(item);
        }
      }
    }

    log('Set grupları oluşturuldu:', setGroups);
    return setGroups;
  }

  function groupCurrentSets(group) {
    let currentSets = Infinity;
    for (const item of group.items) {
      const itemSets = Math.floor(item.quantity / item.expectedQty);
      currentSets = Math.min(currentSets, itemSets);
    }
    return currentSets === Infinity ? 0 : currentSets;
  }

  // Darboğaz stok kontrolü - her beden için max set sayısını hesapla
  async function calculateMaxSets(handle, group) {
    try {
      const cached = productCache[handle];
      const variants = cached && cached.variants ? cached.variants :
        await nativeFetch(`/products/${handle}.js`).then(r => r.json()).then(p => p.variants);

      let maxSets = Infinity;
      let limitingFactor = '';
      let hasInventoryData = false;

      for (const [size, expectedQty] of Object.entries(group.distribution)) {
        if (expectedQty <= 0) continue;

        const normalizedSize = normalizeSize(size);

        const variant = variants ? variants.find(v => {
          const parts = (v.title || '').split('/').map(p => normalizeSize(p));
          if (parts.includes(normalizedSize)) return true;
          if (normalizeSize(v.option1) === normalizedSize) return true;
          if (normalizeSize(v.option2) === normalizedSize) return true;
          if (normalizeSize(v.option3) === normalizedSize) return true;
          return false;
        }) : null;

        if (!variant || !variant.available) {
          maxSets = 0;
          limitingFactor = `${size} (indisponibil)`;
          break;
        }

        if (variant.inventory_quantity !== undefined && variant.inventory_quantity !== null) {
          hasInventoryData = true;
          const possibleSets = Math.floor(variant.inventory_quantity / expectedQty);
          if (possibleSets < maxSets) {
            maxSets = possibleSets;
            limitingFactor = `${size} (stoc: ${variant.inventory_quantity}, necesită: ${expectedQty}/set)`;
          }
        }
      }

      if (!hasInventoryData) maxSets = 99;
      if (maxSets === Infinity) maxSets = 99;

      log(`Max sets for ${handle}: ${maxSets}, limiting: ${limitingFactor}`);
      return { maxSets, limitingFactor };
    } catch (error) {
      log('Stock check error:', error);
      return { maxSets: 99, limitingFactor: '' };
    }
  }

  // ============================================================
  // SEPET GÜNCELLEME (tek /cart/update isteği, sections dahil)
  // ============================================================
  async function batchUpdateCart(updates, sections) {
    const body = { updates: updates || {} };
    const secs = (sections && sections.length) ? sections : collectSections();
    if (secs.length) body.sections = secs;

    return nativeFetch(routes().update, {
      method: 'POST',
      headers: jsonHeaders(),
      body: JSON.stringify(body)
    });
  }

  // Eksik varyantları sepete ekle (tek istek, items[])
  async function addMissingVariants(handle, group, sets) {
    if (sets === 0) return;

    const existingSizes = group.items.map(item => item.size);
    const missingSizes = Object.keys(group.distribution).filter(size => !existingSizes.includes(size));

    if (missingSizes.length === 0) return;

    log('Eksik bedenler bulundu:', missingSizes);

    try {
      const product = productCache[handle] && productCache[handle].variants
        ? { variants: productCache[handle].variants }
        : await nativeFetch(`/products/${handle}.js`).then(r => r.json());

      const items = [];
      for (const size of missingSizes) {
        const normalizedSize = normalizeSize(size);

        const variant = product.variants.find(v => {
          if (normalizeSize(v.option1) === normalizedSize) return true;
          if (normalizeSize(v.option2) === normalizedSize) return true;
          if (normalizeSize(v.option3) === normalizedSize) return true;
          const titleParts = (v.title || '').split('/').map(p => normalizeSize(p));
          return titleParts.includes(normalizedSize);
        });

        if (variant && variant.available) {
          items.push({ id: variant.id, quantity: group.distribution[size] * sets });
        }
      }

      if (items.length) {
        const headers = jsonHeaders();
        headers[internalRequestFlag] = 'true';
        const r = await nativeFetch(routes().add, {
          method: 'POST',
          headers,
          body: JSON.stringify({ items })
        });
        log(`Eksik bedenler eklendi (${r.status}):`, items);
      }

      await groupSetItems();
    } catch (error) {
      log('Eksik varyant ekleme hatası:', error);
    }
  }

  // Multi-size set için tüm bedenleri güncelle (stok kontrollü). Response döner.
  async function updateMultiSizeSet(handle, operation, sections) {
    const group = setGroups.get(handle);
    if (!group || !group.info.isMultiSize) return null;

    log('=== UPDATE MULTI-SIZE SET ===');
    log('Handle:', handle);
    log('Operation:', operation);
    log('Group items:', group.items.map(i => `${i.size}:${i.quantity} (expected:${i.expectedQty})`));

    const currentSets = groupCurrentSets(group);
    log('Current sets:', currentSets);

    let newSets;
    if (operation === 'increase') {
      newSets = currentSets + 1;
    } else if (operation === 'decrease') {
      newSets = Math.max(0, currentSets - 1);
    } else {
      newSets = Math.max(0, Math.round(operation));
    }

    if (newSets > 0) {
      const stockCheck = await calculateMaxSets(handle, group);
      if (newSets > stockCheck.maxSets) {
        log(`Stock bottleneck! Requested: ${newSets}, max: ${stockCheck.maxSets}, limiting: ${stockCheck.limitingFactor}`);
        newSets = stockCheck.maxSets;
        showNotification(t('stockLimitedMax', { sets: newSets, factor: stockCheck.limitingFactor }), 'warning');
      }
    }

    log('New sets:', newSets);

    if (newSets > 0 && group.distribution) {
      await addMissingVariants(handle, group, newSets);
    }

    const freshGroup = setGroups.get(handle) || group;
    const updates = {};
    for (const item of freshGroup.items) {
      const newQty = newSets * item.expectedQty;
      updates[item.key] = newQty;
      log(`UPDATE: ${item.size}: ${item.quantity} → ${newQty} (${item.expectedQty} x ${newSets} set)`);
    }

    const response = await batchUpdateCart(updates, sections);

    if (newSets === 0) {
      showNotification(t('setDeleted', { setType: t('setTypeMulti'), title: group.info.title }), 'success');
    } else {
      const changeText = operation === 'increase' ? '+1 set' :
        operation === 'decrease' ? '-1 set' :
          `${newSets} set`;
      const itemsText = freshGroup.items.map(item => `${item.size}: ${item.expectedQty * newSets}`).join(', ');
      showNotification(`${group.info.title}: ${changeText} (${itemsText})`, 'success');
    }

    return response;
  }

  // Cevaptaki sepeti temaya yayınla (drawer + sepet sayfası yeniden çizilir)
  async function publishFromResponse(response) {
    if (!response) return;
    let cart = null;
    try { cart = await response.clone().json(); } catch (_) { cart = null; }
    if (!cart || cart.errors || cart.status) {
      log('publishFromResponse: cevap kullanılamadı', cart);
      return;
    }
    publishCartUpdate(cart);
  }

  function publishCartUpdate(cart) {
    try {
      if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'yakups-set', cart });
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
      }
    } catch (e) {
      console.error('[Cart Set] publish error:', e.message || e);
    }
    try { document.dispatchEvent(new CustomEvent('cart:update')); } catch (_) { /* ignore */ }
  }

  // Sepete girince otomatik düzeltme - oranları kontrol et ve düzelt
  async function validateAndFixCart() {
    log('=== SMART CART VALIDATION ===');

    for (const [handle, group] of Array.from(setGroups.entries())) {
      if (!group.info.isMultiSize) continue;
      if (group.items.length === 0) continue;

      let currentSets = Infinity;
      let needsFix = false;

      for (const item of group.items) {
        const itemSets = item.quantity / item.expectedQty;
        currentSets = Math.min(currentSets, Math.floor(itemSets));

        if (!Number.isInteger(itemSets)) {
          needsFix = true;
          log(`Ratio broken: ${item.size} has ${item.quantity}, expected multiple of ${item.expectedQty}`);
        }
      }

      if (currentSets === Infinity) currentSets = 0;

      for (const item of group.items) {
        const expected = currentSets * item.expectedQty;
        if (item.quantity !== expected) {
          needsFix = true;
          log(`Mismatch: ${item.size} has ${item.quantity}, should be ${expected} for ${currentSets} sets`);
        }
      }

      const existingSizes = group.items.map(i => i.size);
      const expectedSizes = Object.keys(group.distribution);
      const missingSizes = expectedSizes.filter(s => !existingSizes.includes(s));
      if (missingSizes.length > 0 && currentSets > 0) {
        needsFix = true;
        log(`Missing sizes in cart: ${missingSizes.join(', ')}`);
      }

      if (!needsFix) {
        log(`${handle}: Cart is correct (${currentSets} sets)`);
        continue;
      }

      const stockCheck = await calculateMaxSets(handle, group);
      const safeSets = Math.min(currentSets, stockCheck.maxSets);

      log(`Fixing ${handle}: ${currentSets} sets → ${safeSets} sets (stock max: ${stockCheck.maxSets})`);

      const resp = await updateMultiSizeSet(handle, safeSets);
      await publishFromResponse(resp);

      if (safeSets < currentSets) {
        showNotification(t('stockLimitedAdjusted', { title: group.info.title, sets: safeSets, factor: stockCheck.limitingFactor }), 'warning');
      } else {
        const itemsText = Object.entries(group.distribution).map(([size, qty]) => `${size}: ${qty * safeSets}`).join(', ');
        showNotification(t('quantitiesCorrected', { title: group.info.title, sets: safeSets, items: itemsText }), 'info');
      }
    }

    log('=== SMART CART VALIDATION COMPLETE ===');
  }

  // ============================================================
  // FETCH INTERCEPTOR — temanın /cart/change ve /cart/update istekleri
  // ============================================================
  function parseCartBody(urlStr, body) {
    let lineKey, requestedQty, sections = null, json = null, isUpdatesMap = false;

    const readParams = (p) => {
      lineKey = p.get('id') || p.get('line');
      const q = p.get('quantity');
      if (q !== null) requestedQty = parseInt(q);
      const s = p.getAll ? p.getAll('sections') : [];
      if (s && s.length) sections = s.join(',').split(',').map(x => x.trim()).filter(Boolean);
      for (const k of p.keys()) { if (/^updates\[/.test(k)) isUpdatesMap = true; }
    };

    try {
      if (body instanceof FormData || body instanceof URLSearchParams) {
        readParams(body);
      } else if (typeof body === 'string' && body.length > 0) {
        try { json = JSON.parse(body); } catch (_) { json = null; }
        if (json && typeof json === 'object') {
          lineKey = json.id !== undefined ? String(json.id) : (json.line !== undefined ? String(json.line) : undefined);
          if (json.quantity !== undefined) requestedQty = parseInt(json.quantity);
          if (json.updates) isUpdatesMap = true;
          if (json.sections !== undefined) {
            sections = Array.isArray(json.sections) ? json.sections.slice() : String(json.sections).split(',').map(x => x.trim()).filter(Boolean);
          }
        } else {
          readParams(new URLSearchParams(body));
        }
      }
    } catch (_) { /* ignore */ }

    if (!lineKey) {
      const idMatch = urlStr.match(/[?&](?:id|line)=([^&]+)/);
      if (idMatch) lineKey = decodeURIComponent(idMatch[1]);
    }
    if (requestedQty === undefined || requestedQty === null || isNaN(requestedQty)) {
      const qtyMatch = urlStr.match(/[?&]quantity=(\d+)/);
      if (qtyMatch) requestedQty = parseInt(qtyMatch[1]);
    }

    return { lineKey, requestedQty, sections, json, isUpdatesMap };
  }

  function isSetCounterInput(key) {
    return !!document.querySelector('input[data-index="' + cssEscape(key) + '"][data-set-counter="true"]');
  }

  // İstenen adet → set sayısı (yön duyarlı: artış ceil, azalış floor)
  function resolveRequestedSets(key, requestedQty, currentItem, currentSets) {
    if (requestedQty <= 0) return 0;
    if (isSetCounterInput(key)) return Math.max(0, Math.round(requestedQty));

    const expected = Number(currentItem.expectedQty) || 1;
    const current = Number(currentItem.quantity) || 0;
    const delta = requestedQty - current;

    if (delta > 0) return Math.ceil(requestedQty / expected);
    if (delta < 0) return Math.floor(requestedQty / expected);
    return Math.max(0, Math.round(requestedQty / expected));
  }

  // Tek varyantlı set: istenen adedi set katına yuvarla (+/- → ±1 set)
  function roundToMultiple(requestedQty, currentQty, multiplier) {
    if (requestedQty <= 0) return 0;
    const delta = requestedQty - currentQty;
    if (delta !== 0 && Math.abs(delta) < multiplier) {
      const sets = Math.max(0, Math.round(currentQty / multiplier) + (delta > 0 ? 1 : -1));
      return sets * multiplier;
    }
    return Math.max(0, Math.round(requestedQty / multiplier)) * multiplier;
  }

  function interceptCart() {
    const originalFetch = window.fetch;

    window.fetch = async function (url, options = {}) {
      const urlStr = typeof url === 'string' ? url : (url && url.url) || '';
      const isCartMutation = !!urlStr && (urlStr.includes('/cart/change') || urlStr.includes('/cart/update'));

      if (!isCartMutation) {
        return originalFetch.call(this, url, options);
      }

      try {
        const parsed = parseCartBody(urlStr, options && options.body);

        if (parsed.isUpdatesMap || !parsed.lineKey || parsed.requestedQty === undefined || isNaN(parsed.requestedQty)) {
          return originalFetch.call(this, url, options);
        }

        const cart = await fetchCartJson();
        const cartItem = cart.items.find(i => i.key === parsed.lineKey);
        if (!cartItem) {
          return originalFetch.call(this, url, options);
        }

        await groupSetItems(cart);
        const handle = itemHandle(cartItem);
        const group = setGroups.get(handle);
        if (!group) {
          return originalFetch.call(this, url, options);
        }

        if (group.info.isMultiSize) {
          const currentItem = group.items.find(i => i.key === parsed.lineKey);
          if (!currentItem) {
            return originalFetch.call(this, url, options);
          }

          const currentSets = groupCurrentSets(group);
          const newSets = resolveRequestedSets(parsed.lineKey, parsed.requestedQty, currentItem, currentSets);
          log(`Fetch intercept: ${currentItem.size} requested=${parsed.requestedQty}, expectedQty=${currentItem.expectedQty}, currentSets=${currentSets} → ${newSets} sets`);

          const resp = await updateMultiSizeSet(handle, newSets, parsed.sections);
          if (resp) return resp;
          return batchUpdateCart({}, parsed.sections);
        }

        const multiplier = group.info.multiplier || group.multiplier || 1;
        if (multiplier > 1) {
          const roundedQty = roundToMultiple(parsed.requestedQty, Number(cartItem.quantity) || 0, multiplier);
          if (roundedQty !== parsed.requestedQty) {
            log(`Single-variant set: rounding ${parsed.requestedQty} → ${roundedQty} (multiplier: ${multiplier})`);

            const body = { id: parsed.lineKey, quantity: roundedQty };
            if (parsed.sections && parsed.sections.length) body.sections = parsed.sections;
            if (parsed.json && parsed.json.sections_url) body.sections_url = parsed.json.sections_url;

            const resp = await originalFetch.call(this, url, {
              ...options,
              method: 'POST',
              headers: jsonHeaders(),
              body: JSON.stringify(body)
            });

            if (roundedQty > (Number(cartItem.quantity) || 0)) showNotification(t('setAdded', { qty: multiplier }), 'success');
            else if (roundedQty > 0) showNotification(t('setRemoved', { qty: multiplier }), 'info');
            else showNotification(t('setDeleted', { setType: t('setTypeSingle'), title: group.info.title }), 'success');

            return resp;
          }
        }
      } catch (error) {
        log('Fetch intercept error:', error);
      }

      return originalFetch.call(this, url, options);
    };
  }

  // ============================================================
  // SEPET DOM'U (rozet + tek satıra indirme)
  // ============================================================
  const ROW_SELECTOR = 'tr.cart-item, li.horizontal-product, [id^="CartItem-"], [id^="CartDrawer-Item-"]';

  function getRowKey(row) {
    const input = row.querySelector('input[data-index]');
    if (input) return input.getAttribute('data-index');
    const id = row.id || '';
    if (id.startsWith('CartDrawer-Item-')) return id.slice('CartDrawer-Item-'.length);
    if (id.startsWith('CartItem-')) return id.slice('CartItem-'.length);
    return null;
  }

  function getHandleFromRow(row) {
    if (row.dataset && row.dataset.handle) return row.dataset.handle;
    const link = row.querySelector('a[href*="/products/"]');
    if (link) {
      const url = link.getAttribute('href') || link.href || '';
      const match = url.match(/\/products\/([^?#/]+)/);
      if (match) return match[1];
    }
    return null;
  }

  function getContainers() {
    const list = Array.from(document.querySelectorAll('cart-items'));
    return list.length ? list : [document];
  }

  function rowsIn(container) {
    return Array.from(container.querySelectorAll(ROW_SELECTOR)).filter(r => r.querySelector('input[data-index]') || r.id);
  }

  function insertBadge(row, badge) {
    const details = row.querySelector('.cart-item__details, .horizontal-product__details');
    if (details) {
      const anchor = details.firstElementChild;
      if (anchor) anchor.insertAdjacentElement('afterend', badge);
      else details.appendChild(badge);
      return;
    }
    const priceEl = row.querySelector('.price');
    if (priceEl && priceEl.parentNode) {
      priceEl.parentNode.insertBefore(badge, priceEl);
      return;
    }
    row.appendChild(badge);
  }

  function badgeBase(className) {
    const badge = document.createElement('div');
    badge.className = className;
    badge.style.cssText = `
      display: inline-flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 6px;
      padding: 4px 10px;
      margin: 4px 0;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      font-size: 11px;
      color: #555;
      background: #fafafa;
      line-height: 1.4;
    `;
    return badge;
  }

  function addMultiSizeBadge(row, group) {
    if (row.querySelector('.multi-size-badge')) return;

    const badge = badgeBase('multi-size-badge');
    const parts = group.items.map(i => `<span style="font-weight:600;">${i.size}</span><span style="color:#999;">&times;${i.expectedQty}</span>`);
    const totalQty = group.items.reduce((s, i) => s + (Number(i.quantity) || 0), 0);
    const totalCents = group.items.reduce((s, it) => s + (Number(it.final_line_price) || 0), 0);

    badge.innerHTML = `
      <span style="color:#888;">Set</span>
      <span style="display:inline-flex;gap:6px;">${parts.join('<span style="color:#ddd;">|</span>')}</span>
      <span style="color:#ddd;">|</span>
      <span style="color:#888;">${t('totalLabel')}</span>
      <span style="font-weight:700;color:#333;">${totalQty} ${t('pieceUnit')}</span>
      ${totalCents > 0 ? `<span style="color:#ddd;">|</span><span style="color:#888;">${t('setTotalLabel')}</span><span style="font-weight:700;color:#333;">${formatMoney(totalCents)}</span>` : ''}
    `;

    insertBadge(row, badge);
  }

  function addSingleVariantBadge(row, multiplier, totalQty) {
    if (row.querySelector('.single-variant-badge')) return;

    const badge = badgeBase('single-variant-badge');
    badge.innerHTML = `
      <span style="color:#888;">Set</span>
      <span style="font-weight:600;">&times;${multiplier}</span>
      ${(Number(totalQty) > 0) ? `
      <span style="color:#ddd;">|</span>
      <span style="color:#888;">${t('totalLabel')}</span>
      <span style="font-weight:700;color:#333;">${totalQty} ${t('pieceUnit')}</span>` : ''}
    `;

    insertBadge(row, badge);
  }

  // Bir multi-size SET'i konteyner içinde TEK satıra indir
  function consolidateSetRows(container, handle, group) {
    try {
      if (!group || !group.info || !group.info.isMultiSize) return;
      if (!group.items || group.items.length < 2) return;

      const keys = group.items.map(i => i.key);
      const rows = rowsIn(container).filter(r => keys.includes(getRowKey(r)));
      if (rows.length < 2) return;

      const primary = rows[0];
      if (primary.dataset.setPrimary === 'true') {
        rows.slice(1).forEach((r) => { r.style.display = 'none'; r.dataset.setMerged = 'true'; });
        return;
      }

      const primaryKey = getRowKey(primary);
      const primaryItem = group.items.find(i => i.key === primaryKey) || group.items[0];

      rows.slice(1).forEach((r) => { r.style.display = 'none'; r.dataset.setMerged = 'true'; });

      const setCount = Math.max(1, Math.round((Number(primaryItem.quantity) || 0) / (Number(primaryItem.expectedQty) || 1)));
      const qInput = primary.querySelector('input[name="updates[]"], input[data-index]');
      if (qInput) {
        qInput.dataset.setCounter = 'true';
        if (String(qInput.value) !== String(setCount)) qInput.value = setCount;
        qInput.setAttribute('title', 'Set');
      }

      const distSizes = Object.keys(group.distribution || {}).map((s) => normalizeSize(s));
      primary.querySelectorAll('dl > div').forEach((div) => {
        const dd = div.querySelector('dd');
        if (!dd) return;
        const firstText = (dd.childNodes[0] && dd.childNodes[0].textContent) || dd.textContent || '';
        const val = normalizeSize(firstText);
        if (val && distSizes.includes(val)) div.style.display = 'none';
      });

      const totalCents = group.items.reduce((s, it) => s + (Number(it.final_line_price) || 0), 0);
      if (totalCents > 0) {
        const formatted = formatMoney(totalCents);
        const lineTotal = primary.matches('tr') ? primary.querySelector('td:last-child .price') : null;
        if (lineTotal) {
          lineTotal.textContent = formatted;
        } else {
          const priceEl = primary.querySelector('.horizontal-product__details .price');
          if (priceEl) {
            const regular = priceEl.querySelector('.price__regular');
            if (regular) regular.textContent = formatted;
            else priceEl.textContent = formatted;
          }
        }
      }

      primary.dataset.setPrimary = 'true';
    } catch (e) {
      console.error('[Cart Set] consolidate error:', e.message || e);
    }
  }

  let setupRunning = false;
  let setupQueued = false;

  async function setupCartPageControls() {
    if (setupRunning) { setupQueued = true; return; }
    setupRunning = true;

    try {
      const rows = document.querySelectorAll(ROW_SELECTOR);
      if (rows.length === 0) return;

      let cart;
      try { cart = await fetchCartJson(); } catch (_) { return; }
      await groupSetItems(cart);

      log(`Cart rows found: ${rows.length}`);

      for (const row of rows) {
        const handle = getHandleFromRow(row);
        if (!handle) continue;

        const group = setGroups.get(handle);
        if (!group) continue;

        if (group.info.isMultiSize) {
          addMultiSizeBadge(row, group);
        } else {
          const multiplier = group.info.multiplier || group.multiplier || 1;
          if (multiplier > 1) {
            const singleTotal = group.items.reduce((s, i) => s + (Number(i.quantity) || 0), 0);
            addSingleVariantBadge(row, multiplier, singleTotal);
          }
        }
      }

      for (const container of getContainers()) {
        for (const [h, g] of setGroups) {
          if (g && g.info && g.info.isMultiSize) consolidateSetRows(container, h, g);
        }
      }
    } finally {
      setupRunning = false;
      if (setupQueued) {
        setupQueued = false;
        setTimeout(setupCartPageControls, 50);
      }
    }
  }

  // ============================================================
  // BİLDİRİM / STİL / OLAYLAR
  // ============================================================
  function showNotification(message, type = 'info') {
    const existing = document.querySelector('.cart-set-notification');
    if (existing) existing.remove();

    const colors = {
      success: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      info: 'linear-gradient(135deg, #36D1DC 0%, #5B86E5 100%)',
      warning: 'linear-gradient(135deg, #FF6B6B 0%, #FFE66D 100%)'
    };

    const notification = document.createElement('div');
    notification.className = 'cart-set-notification';
    notification.style.cssText = `
      position: fixed;
      bottom: 30px;
      right: 30px;
      background: ${colors[type] || colors.info};
      color: white;
      padding: 16px 24px;
      border-radius: 12px;
      box-shadow: 0 10px 40px rgba(0,0,0,0.2);
      z-index: 99999;
      animation: slideInBounce 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
      font-size: 14px;
      font-weight: 500;
      max-width: 400px;
      display: flex;
      align-items: center;
      gap: 12px;
    `;

    const icons = { success: '✓', info: 'ℹ', warning: '⚠' };

    notification.innerHTML = `
      <span style="font-size: 20px; font-weight: bold;">${icons[type] || icons.info}</span>
      <span>${message}</span>
    `;

    document.body.appendChild(notification);

    setTimeout(() => {
      notification.style.animation = 'slideOutBounce 0.4s ease-in';
      setTimeout(() => notification.remove(), 400);
    }, 3500);
  }

  function addStyles() {
    if (document.querySelector('#cart-set-styles')) return;

    const style = document.createElement('style');
    style.id = 'cart-set-styles';
    style.textContent = `
      @keyframes slideInBounce {
        0% { transform: translateX(120%) scale(0.8); opacity: 0; }
        60% { transform: translateX(-10%) scale(1.02); opacity: 1; }
        100% { transform: translateX(0) scale(1); opacity: 1; }
      }
      @keyframes slideOutBounce {
        from { transform: translateX(0) scale(1); opacity: 1; }
        to { transform: translateX(120%) scale(0.8); opacity: 0; }
      }
      [data-set-merged="true"] { display: none !important; }
    `;
    document.head.appendChild(style);
  }

  let debounceTimer = null;
  function scheduleSetup(delay) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => { setupCartPageControls(); }, delay || 250);
  }

  function addEventListeners() {
    document.addEventListener('cart:refresh', () => scheduleSetup(500));
    document.addEventListener('cart:updated', () => scheduleSetup(300));
  }

  function observeChanges() {
    const observer = new MutationObserver((mutations) => {
      let cartRelated = false;
      for (const m of mutations) {
        const nodes = [...m.addedNodes, ...m.removedNodes];
        for (const node of nodes) {
          if (node.nodeType !== 1) continue;
          if ((node.matches && node.matches(ROW_SELECTOR)) ||
              (node.querySelector && node.querySelector(ROW_SELECTOR))) {
            cartRelated = true;
            break;
          }
        }
        if (cartRelated) break;
      }

      if (!cartRelated) return;
      scheduleSetup(250);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  async function init() {
    log('Cart Set Multiplier başlatılıyor...');

    addStyles();
    interceptCart();
    await setupCartPageControls();

    if (window.location.pathname.includes('/cart')) {
      await validateAndFixCart();
    }

    addEventListeners();
    observeChanges();

    log('Hazır! Set grupları:', setGroups);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // set parser'ı dışa aç — cart-export.js "Set İçeriği"ni buradan okur (tek doğru kaynak)
  window.YakupsSetParser = {
    parse: parseCompleteSetInfo,
    auto: computeAutoSetInfo,
    parseProduct: function (product) {
      if (!product) return null;
      return parseCompleteSetInfo(product.description || '', product.title || '') || computeAutoSetInfo(product);
    }
  };

})();
